export default "__VITE_ASSET__6bcbcbf9__"